var map = {
	"./1111.svg": 99654,
	"./add-icon.svg": 73425,
	"./answer-lottery.svg": 67418,
	"./apply-active.svg": 39537,
	"./apply-big-icon.svg": 34054,
	"./apply-speech-icon.svg": 34860,
	"./apply.svg": 96265,
	"./arrow-border-down.svg": 36734,
	"./arrow-right.svg": 23665,
	"./arrow-up.svg": 87354,
	"./auction.svg": 68136,
	"./audio-connect.svg": 90348,
	"./audio-muted.svg": 43504,
	"./audio.svg": 36889,
	"./avatar-icon.svg": 70416,
	"./beauty.svg": 20943,
	"./calling.svg": 31559,
	"./camera-closed.svg": 41426,
	"./camera-off-gray.svg": 6722,
	"./camera-off.svg": 25877,
	"./camera-on.svg": 67551,
	"./camera.svg": 44390,
	"./chat-active.svg": 26748,
	"./chat.svg": 24927,
	"./checked.svg": 30931,
	"./choose-on.svg": 92677,
	"./close.svg": 19814,
	"./copy-icon.svg": 82210,
	"./copy.svg": 1002,
	"./edit.svg": 36439,
	"./emoji-new.svg": 95621,
	"./emoji.svg": 81356,
	"./error.svg": 46490,
	"./exit-fullscreen.svg": 46779,
	"./exit.svg": 28498,
	"./free-speech-icon.svg": 4735,
	"./full-screen.svg": 68391,
	"./go-off-seat.svg": 62699,
	"./info-forbidden.svg": 17554,
	"./info.svg": 92194,
	"./invite-active.svg": 65362,
	"./invite.svg": 42637,
	"./lang.svg": 46079,
	"./language.svg": 64884,
	"./layout.svg": 637,
	"./line-arrow-down.svg": 98763,
	"./line-arrow-up.svg": 18319,
	"./mail-icon.svg": 346,
	"./manage-member-active.svg": 93553,
	"./manage-member.svg": 2429,
	"./mic-off-gray.svg": 83421,
	"./mic-off.svg": 51873,
	"./mic-on.svg": 51042,
	"./mic.svg": 47784,
	"./minimize-screen.svg": 68684,
	"./more-active.svg": 24238,
	"./more.svg": 61409,
	"./pause.svg": 98281,
	"./phone-icon.svg": 28826,
	"./play.svg": 34946,
	"./quit-full-screen.svg": 50159,
	"./red-pocket.svg": 86703,
	"./screen-share-disabled.svg": 69447,
	"./screen-share-stopped.svg": 55784,
	"./screen-share.svg": 72214,
	"./screen-sharing.svg": 32009,
	"./setting-active.svg": 63152,
	"./setting.svg": 56976,
	"./share.svg": 74635,
	"./shopping.svg": 76885,
	"./switch-language.svg": 50812,
	"./turn-page-arrow-left.svg": 70672,
	"./user.svg": 68769,
	"./verify-code.svg": 2774,
	"./video-connect.svg": 76187,
	"./video-muted.svg": 45756,
	"./voice.svg": 6160,
	"./vote-active.svg": 29265,
	"./vote.svg": 84826,
	"./vote1.svg": 90087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;